import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import {
  Route,
  BrowserRouter as Router,
  Routes,
  useLocation,
} from "react-router-dom";
import Navbar from "./components/navbar";
import Home from "./page/home";
import Contact from "./page/contact";
import Sidesocialmedia from "./components/sidesocialmedia/sidesocialmedia";
import DailyDarshan from "./page/daily-darshan";
import EventPhotos from "./page/events";
import Nirnay from "./page/nirnay";
import Books from "./page/books"
import BookReader from "./page/book-reader";
import Wallpaper from "./page/wallpaper";
import AudioAlbum from "./page/audio-album";
import AudioAlbumDetail from "./page/audio-album-detail";
import MantraLekhanSignIn from "./page/mantra-lekhan-signin";
import MantraLekhanDashboard from "./page/mantra-lekhan-dashboard";
import Video from "./page/video";

const root = ReactDOM.createRoot(document.getElementById("root"));

function AppWrapper() {
  const location = useLocation();
  const isMantraLekhanPage = location.pathname.includes("mantra-lekhan");

  return (
    <>
      {!isMantraLekhanPage && <Navbar />}
      {!isMantraLekhanPage && <sidesocialmedia />}
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/contactus" element={<Contact />} />
        <Route path="/daily-darshan" element={<DailyDarshan />} />
        <Route path="/events" element={<EventPhotos />} />
        <Route path="/nirnay" element={<Nirnay />} />
        <Route path="/books" element={<Books />} />
        <Route path="/books/index/:bookId" element={<BookReader />} />
        <Route path="/videos" element={<Video />} />
        <Route path="/wallpaper" element={<Wallpaper />} />
        <Route path="/audio-album" element={<AudioAlbum />} />
        <Route path="/audio-album/:albumId" element={<AudioAlbumDetail />} />
        <Route path="/mantra-lekhan-signin" element={<MantraLekhanSignIn />} />
        <Route
          path="/mantra-lekhan-dashboard"
          element={<MantraLekhanDashboard />}
        />
      </Routes>
      <App />
    </>
  );
}

root.render(
  <React.StrictMode>
    <Router>
      <AppWrapper />
    </Router>
  </React.StrictMode>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
